import { render, staticRenderFns } from "./DSPayoutsIcon.vue?vue&type=template&id=69df9009&scoped=true&"
import script from "./DSPayoutsIcon.vue?vue&type=script&lang=js&"
export * from "./DSPayoutsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69df9009",
  null
  
)

export default component.exports